<ng-container *ngIf="!state.user">
  <div
    id="g_id_onload"
    data-client_id="387343500342-obn0crc436d0kubai59g2frmat1sbmvl.apps.googleusercontent.com"
    data-context="signin"
    data-callback="googleOneTapPostLogin"
    data-cancel_on_tap_outside="false"
    data-prompt_parent_id="g_id_onload"
    style="position: fixed; right: 5px; z-index: 50"
    [style.top]="topSpacing + 'px'"
    [class.hidden]="!showOneTap"
    *onlyForScreens="['desktop', 'tablet']"
  ></div>
  <div *onlyForScreens="['mobile']">
    <div
      id="g_id_onload"
      data-client_id="387343500342-obn0crc436d0kubai59g2frmat1sbmvl.apps.googleusercontent.com"
      data-context="signin"
      data-callback="googleOneTapPostLogin"
      data-cancel_on_tap_outside="false"
      data-prompt_parent_id="g_id_onload"
      style="position: fixed; right: 5px; z-index: 50"
      [style.top]="topSpacing + 'px'"
      *ngIf="showOneTap"
    ></div>
  </div>
</ng-container>
